import { render } from "./ChampionsView.vue?vue&type=template&id=247a1a68"
import script from "./ChampionsView.vue?vue&type=script&lang=js"
export * from "./ChampionsView.vue?vue&type=script&lang=js"

import "./ChampionsView.vue?vue&type=style&index=0&id=247a1a68&lang=css"

import exportComponent from "C:\\Development\\konnektor\\scores\\kon-platform-wallboards-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__